import { ofType } from "redux-observable";
import { filter, ignoreElements, retry, switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
export var epicLoginChatServer = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.Received), filter(isLoginTokenSet), switchMap(function () {
        var state = state$.value;
        var playerId = state.playerInfo.playerId;
        var loginToken = utilPersistence.getValue(IdPersistence.Credentials, {}).loginToken;
        return deps
            .chatNetSend({
            id: CommandCode.LoginChatServer,
            props: {
                authenticationToken: loginToken,
                playerId: playerId,
            },
        })
            .pipe(retry(), ignoreElements());
    }));
};
var isLoginTokenSet = function () {
    var credentials = utilPersistence.getValue(IdPersistence.Credentials);
    return credentials != undefined && credentials.loginToken != undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/epics/epicLoginChatServer.ts
// module id = 1794
// module chunks = 3